(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Restore collection scroll position when returning from a product.
   * This is mainly intended to fix the iPhone/Safari back-button issue.
   */
  (() => {
    const isCollectionPage = window.location.pathname.includes('/collections/');

    if (!isCollectionPage) return;

    const storageKey = `collection-scroll-${window.location.pathname}${window.location.search}`;

    /*
     * Tell the browser that we will handle scroll restoration ourselves.
     * This prevents Safari from fighting with our restoration code.
     */
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    /*
     * Save the scroll position while the customer is browsing.
     */
    let saveTimer;

    window.addEventListener(
      'scroll',
      () => {
        clearTimeout(saveTimer);

        saveTimer = setTimeout(() => {
          sessionStorage.setItem(
            storageKey,
            JSON.stringify({
              top: window.scrollY,
              timestamp: Date.now()
            })
          );
        }, 100);
      },
      { passive: true }
    );

    /*
     * Restore the position when the customer comes back
     * using the browser's Back button.
     */
    window.addEventListener('pageshow', (event) => {
      const navigationEntry = performance.getEntriesByType('navigation')[0];

      const isBackForward =
        event.persisted ||
        navigationEntry?.type === 'back_forward';

      if (!isBackForward) return;

      const savedPosition = sessionStorage.getItem(storageKey);

      if (!savedPosition) return;

      try {
        const position = JSON.parse(savedPosition);

        /*
         * Wait for Horizon's collection/infinite-scroll content
         * to be available before restoring the position.
         */
        const restoreScroll = () => {
          const maxScroll =
            document.documentElement.scrollHeight - window.innerHeight;

          const target = Math.min(position.top, Math.max(0, maxScroll));

          window.scrollTo({
            top: target,
            left: 0,
            behavior: 'instant'
          });
        };

        /*
         * Multiple attempts are intentional.
         * On iPhone Safari, the collection can finish rendering
         * after pageshow fires.
         */
        requestAnimationFrame(() => {
          restoreScroll();

          setTimeout(restoreScroll, 100);
          setTimeout(restoreScroll, 300);
          setTimeout(restoreScroll, 600);
        });
      } catch (error) {
        sessionStorage.removeItem(storageKey);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
